import { IBusinessCardExtractionResponse } from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { DataItemProps } from "../../../../../../shared/components/DataView";

export const mapBusinessCardExtractedFieldsToDataView = (
  extractedFields: IBusinessCardExtractionResponse
): DataItemProps[] => {
  const dataItems: DataItemProps[] = [];

  if (extractedFields.personalInfo?.fullName) {
    dataItems.push({
      label: "Full name",
      value: extractedFields.personalInfo.fullName
    });
  }

  if (extractedFields.personalInfo?.title) {
    dataItems.push({
      label: "Title",
      value: extractedFields.personalInfo.title
    });
  }

  if (extractedFields.personalInfo?.department) {
    dataItems.push({
      label: "Department",
      value: extractedFields.personalInfo.department
    });
  }

  if (extractedFields.companyInfo?.companyName) {
    dataItems.push({
      label: "Company name",
      value: extractedFields.companyInfo.companyName
    });
  }

  if (extractedFields.companyInfo?.tagline) {
    dataItems.push({
      label: "Tagline",
      value: extractedFields.companyInfo.tagline
    });
  }

  if (extractedFields.companyInfo?.industry) {
    dataItems.push({
      label: "Industry",
      value: extractedFields.companyInfo.industry
    });
  }

  if (extractedFields.contactDetails?.mobilePhone) {
    dataItems.push({
      label: "Mobile phone",
      value: extractedFields.contactDetails.mobilePhone
    });
  }

  if (extractedFields.contactDetails?.officePhone) {
    dataItems.push({
      label: "Office phone",
      value: extractedFields.contactDetails.officePhone
    });
  }

  if (extractedFields.contactDetails?.faxNumber) {
    dataItems.push({
      label: "Fax number",
      value: extractedFields.contactDetails.faxNumber
    });
  }

  if (extractedFields.contactDetails?.emailAddresses?.length) {
    dataItems.push({
      label: "Email addresses",
      value: extractedFields.contactDetails.emailAddresses.join(", ")
    });
  }

  if (extractedFields.contactDetails?.websiteURL) {
    dataItems.push({
      label: "Website URL",
      value: extractedFields.contactDetails.websiteURL
    });
  }

  if (extractedFields.physicalAddress?.streetAddress) {
    dataItems.push({
      label: "Street address",
      value: extractedFields.physicalAddress.streetAddress
    });
  }

  if (extractedFields.physicalAddress?.city) {
    dataItems.push({
      label: "City",
      value: extractedFields.physicalAddress.city
    });
  }

  if (extractedFields.physicalAddress?.state) {
    dataItems.push({
      label: "State",
      value: extractedFields.physicalAddress.state
    });
  }

  if (extractedFields.physicalAddress?.zipCode) {
    dataItems.push({
      label: "Zip code",
      value: extractedFields.physicalAddress.zipCode
    });
  }

  if (extractedFields.physicalAddress?.country) {
    dataItems.push({
      label: "Country",
      value: extractedFields.physicalAddress.country
    });
  }

  if (extractedFields.socialDigital?.linkedinProfile) {
    dataItems.push({
      label: "LinkedIn profile",
      value: extractedFields.socialDigital.linkedinProfile
    });
  }

  if (extractedFields.socialDigital?.twitterHandle) {
    dataItems.push({
      label: "Twitter handle",
      value: extractedFields.socialDigital.twitterHandle
    });
  }

  if (extractedFields.socialDigital?.otherSocialMedia?.length) {
    dataItems.push({
      label: "Other social media",
      value: extractedFields.socialDigital.otherSocialMedia.join(", ")
    });
  }

  return dataItems;
};
